<div class="workday-financials-panel">
  <h5>Workday Financials by Fiscal Year (FY) <span class="text-muted">(USD)</span></h5>

  @if(project.budgetsAndActuals.length) {
    <div class="results-grid" [ngClass]="{'stubby': project.budgetsAndActuals.length <= 8}">
      <div class="results-header">
        <div>Fiscal Year (FY)</div>
        <div>Budgeted Expenses</div>
        <div>Expenses</div>
        <div>Expenses to Budget</div>
      </div>

      <div class="results-body">
        @for (ba of project.budgetsAndActuals; track ba) {
          <div class="result-row">
            <div>
              FY{{ba.fiscalYear}}
            </div>
            <div>
              {{ba.totalBudgetUsdAmount | currency: "USD": "symbol": "1.0-0"}}
            </div>
            <div>
            {{ba.totalActualUsdAmount | currency: "USD": "symbol": "1.0-0"}}
          </div>
          <div class="expenses-to-budget-column">
            @if (ba.totalBudgetUsdAmount) {
              <div class="bar-chart">
                <div class="bar-chart-background"></div>
                <div class="bar-chart-foreground" [style.width.%]="getSeriesWidth(ba)"></div>
              </div>
              <div class="budget-percent">
                {{(ba.totalActualUsdAmount / ba.totalBudgetUsdAmount) | percent:'1.0-1'}}
              </div>
            }
            @else {
            <div class="not-applicable">N/A</div>
          }
        </div>
      </div>
    }
  </div>

  <div class="results-footer">
    <div>Total</div>
    <div class="no-border">
      {{getTotalBudgetedExpenses() | currency: "USD": "symbol": "1.0-0"}}
    </div>
    <div>
    {{getTotalActualExpenses() | currency: "USD": "symbol": "1.0-0"}}
  </div>
</div>

</div>
}
@else {
<div>There is no information to display</div>
}

</div>
